let config = {
  locale: 'en',
  cdnUrl: 'https://assets.yolacdn.net',
};

const configStorage = {
  set(configData) {
    config = configData;
  },
  get() {
    return config;
  },
};

export default configStorage;
